module.exports = __webpack_public_path__ + "img/slika7_2022.e1bfed44.png";